module.exports = __webpack_public_path__ + "static/media/signup.a5bf40f3.webp";